module.exports = __webpack_public_path__ + "static/img/icon33.187b3a32.png";